import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import { Classes } from '@blueprintjs/core';
import { Label } from '@radix-ui/react-dropdown-menu';
import React__default from 'react';

var _excluded = ["children"];
var Heading = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React__default.createElement(Label, _extends({
    asChild: true
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__default.createElement("li", {
    className: Classes.MENU_HEADER
  }, /*#__PURE__*/React__default.createElement("div", {
    className: Classes.HEADING
  }, children)));
});

export { Heading };
//# sourceMappingURL=dropdown-menu-heading.js.map
